export function validateEmail(email, allowEmpty) {
  if (!email && allowEmpty) {
    return true;
  }

  const emailRegex = /^\S+@\S+[\.][0-9a-z]+$/;

  return emailRegex.test((email || '').toLowerCase())
}
